var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m89.898 72.199l-22.898-22.898 22.898-22.898c2.3008-2.3008 2.3008-6.1016 0-8.5l-12.699-12.801-27.199 27.199-27.199-27.199-12.699 12.797c-2.3008 2.3008-2.3008 6.1016 0 8.5l22.898 22.902-22.898 22.898c-2.3008 2.3008-2.3008 6.1016 0 8.5l12.699 12.699 27.199-27.098 27.199 27.199 12.699-12.699c2.4023-2.4023 2.4023-6.1992 0-8.6016z"}));
}

Close.defaultProps = {"width":"100pt","height":"100pt","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Close;

Close.default = Close;
